import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Images from "../../Constants/Images";
import Routes from "../../Constants/Routes";
import SearchBar from "./SearchBar";

function AppNavbar() {
  return (
    <div className="app-navbar">
      <div className="top-bar">
        <Container>
          <Navbar expand="lg">
            <Container fluid>
              <Navbar.Brand as={Link} to={Routes.publicRoutes.HomePage}>
                <img src={Images.logo} alt="logo" className="navbar-logo" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav>
                  <Nav.Link as="div">
                    <SearchBar />
                  </Nav.Link>
                  <Nav.Link as="div" className="navbar-contact">
                    <a href="tel:+91-8799701700" className="btn-sm btn btn-light">
                      <i class='bx bxs-phone-call'></i>
                      +91-8799701700
                    </a>
                    <Link to={Routes.publicRoutes.Consult} className="btn btn-sm btn-primary">
                      <i class='bx bxs-envelope' ></i>
                      appointment
                    </Link>
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Container>
      </div>
      <div className="bottom-bar">
        <Container>
          <Navbar>
            <Container fluid>
              <Nav className="nav-scroll">
                <Nav.Link as={Link} to={Routes.publicRoutes.KidneyFailure}>
                  <img src={Images.kidney} alt="kidney icon" className="nav-icon" />
                  Kidney Failure
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.PainManagement}>
                  <img src={Images.pain} alt="pain icon" className="nav-icon" />
                  Pain Management
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.Diseases}>
                  <img src={Images.disease} alt="disease icon" className="nav-icon" />
                  Diseases
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.Blogs.Medicine.MedicineBlog}>
                  <img src={Images.disease} alt="disease icon" className="nav-icon" />
                  Blogs
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.Blogs.Herbs.HerbsFood}>
                  <img src={Images.herbs} alt="herbs icon" className="nav-icon" />
                  Herbs/Foods
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.Blogs.Video.VideoBlog}>
                  <img src={Images.videos} alt="videos icon" className="nav-icon" />
                  Videos
                </Nav.Link>
                <Nav.Link
                  href="https://store.sabkavaidya.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Images.medicine} alt="medicine icon" className="nav-icon" />
                  Buy Medicine
                </Nav.Link>
                <Nav.Link as={Link} to={Routes.publicRoutes.HealingStories}>
                  <img src={Images.healing} alt="healing icon" className="nav-icon" />
                  Healing Stories
                </Nav.Link>
              </Nav>
            </Container>
          </Navbar>
        </Container>
      </div>
    </div>
  );
}

export default AppNavbar;
